"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NODE_OBJ_TYPE = void 0;
var NODE_OBJ_TYPE;
(function (NODE_OBJ_TYPE) {
    NODE_OBJ_TYPE[NODE_OBJ_TYPE["HTML_ELEMENT"] = 0] = "HTML_ELEMENT";
    NODE_OBJ_TYPE[NODE_OBJ_TYPE["DIRECTIVE"] = 1] = "DIRECTIVE";
})(NODE_OBJ_TYPE || (exports.NODE_OBJ_TYPE = NODE_OBJ_TYPE = {}));
;
